import mapConfig from '@/config/mapConfig'

export const randomNumber = (min, max) => {
	return Math.floor(Math.random()*(max-min+1)+min);
}

export const getAreaCoordRelativeCenter = (center) => {
	let earth = 6378.137
	let pi = Math.PI
	let coefficient = (1 / ((2 * pi / 360) * earth)) / 1000  //1 meter in degree

	let baseLatitude = center[1]
	let baseLongitude = center[0]
	let startLatitude = baseLatitude - (mapConfig.POINT_OF_INTEREST_DISTANCE/2 * coefficient)
	let startLongitude = baseLongitude - (mapConfig.POINT_OF_INTEREST_DISTANCE/2 * coefficient) / Math.cos(baseLatitude * (pi / 180))

	let endLatitude = baseLatitude + (mapConfig.POINT_OF_INTEREST_DISTANCE/2 * coefficient)
	let endLongitude = baseLongitude + (mapConfig.POINT_OF_INTEREST_DISTANCE/2 * coefficient) / Math.cos(baseLatitude * (pi / 180))

	return startLatitude + ',' + startLongitude + ',' + endLatitude + ',' + endLongitude
}

export const getPointOfInterestType = (place) => {
	let type = 'government'
	if(place.tags.amenity == 'school' || place.tags.amenity == 'college') {
		type = 'school'
	}
	else if(place.tags.tourism == 'attraction') {
		type = 'attraction'
	}
	else if(place.tags.amenity == 'hospital' || place.tags.amenity == 'clinic') {
		type = 'hospital'
	}
	else if(	place.tags.industrial == 'port' ||
				place.tags.landuse == 'port' ||
				place.tags.landuse == 'harbour'
	) {
		type = 'port'
	}
	else if(place.tags.highway == 'bus_stop') {
		type = 'bus_station'
	}
	else if(place.tags.railway == 'station') {
		type = 'rail_station'
	}
	else if(place.tags.aeroway == 'aerodrome') {
		type = 'airport'
	}
	return type
}

export const getDistanceBetweenTwoPoints = (point1, point2, unit = 'K') => {
	var radlat1 = Math.PI * point1[1]/180
	var radlat2 = Math.PI * point2[1]/180
	var theta = point1[0] - point2[0]
	var radtheta = Math.PI * theta/180
	var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
	if(dist > 1) {
		dist = 1
	}
	dist = Math.acos(dist)
	dist = dist * 180/Math.PI
	dist = dist * 60 * 1.1515
	if(unit == 'K') {
		dist = dist * 1.609344
	}
	if(unit == 'N') {
		dist = dist * 0.8684
	}
	return dist
}

export const runStatisticAnimation = () => {
	let homePageElement = document.getElementsByClassName('home-page')[0]
	let statisticBarElement = document.getElementsByClassName('statistic-bar')[0]
	let timer = null
	homePageElement.addEventListener('mousemove', () => {
		clearTimeout(timer)
		statisticBarElement.style.opacity = 1
		timer = setTimeout( () => {
			statisticBarElement.style.opacity = 0
		}, 2000)
	})
}

export const renderChart = (element, data) => {
	console.log('run render')
	new Chart(element, {
		type: 'bar',
		data: {
			labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
			datasets: [{
				label: '# of Votes',
				data,
				backgroundColor: [
					'rgba(255, 99, 132, 0.2)',
					'rgba(54, 162, 235, 0.2)',
					'rgba(255, 206, 86, 0.2)',
					'rgba(75, 192, 192, 0.2)',
					'rgba(153, 102, 255, 0.2)',
					'rgba(255, 159, 64, 0.2)'
				],
				borderColor: [
					'rgba(255, 99, 132, 1)',
					'rgba(54, 162, 235, 1)',
					'rgba(255, 206, 86, 1)',
					'rgba(75, 192, 192, 1)',
					'rgba(153, 102, 255, 1)',
					'rgba(255, 159, 64, 1)'
				],
				borderWidth: 1
			}]
		},
		options: {
			scales: {
				yAxes: [{
					ticks: {
						beginAtZero: true
					}
				}]
			}
		}
	})
}